"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectOrder = void 0;
const typeorm_1 = require("typeorm");
const class_transformer_1 = require("class-transformer");
// eslint-disable-next-line import/no-cycle
const Project_1 = require("./Project");
const JournaledEntity_1 = require("../../JournaledEntity");
// eslint-disable-next-line import/no-cycle
const ProjectOffer_1 = require("./ProjectOffer");
// eslint-disable-next-line import/no-cycle
const OrderTask_1 = require("../../project-management/entity/OrderTask");
const CircularReference_1 = require("../../serialization/CircularReference");
let ProjectOrder = class ProjectOrder extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.ProjectOrder = ProjectOrder;
__decorate([
    (0, typeorm_1.OneToOne)(() => Project_1.Project, (p) => p.order),
    (0, typeorm_1.JoinColumn)(),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Project_1.Project)
], ProjectOrder.prototype, "project", void 0);
__decorate([
    (0, typeorm_1.RelationId)((po) => po.project),
    __metadata("design:type", String)
], ProjectOrder.prototype, "projectId", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => ProjectOffer_1.ProjectOffer, (p) => p.order, { nullable: true }),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", ProjectOffer_1.ProjectOffer)
], ProjectOrder.prototype, "offer", void 0);
__decorate([
    (0, typeorm_1.RelationId)((po) => po.offer),
    __metadata("design:type", String)
], ProjectOrder.prototype, "offerId", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp'),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], ProjectOrder.prototype, "orderDate", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => OrderTask_1.OrderTask, (o) => o.order),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Array)
], ProjectOrder.prototype, "orderTasks", void 0);
__decorate([
    (0, typeorm_1.RelationId)((po) => po.orderTasks),
    __metadata("design:type", Array)
], ProjectOrder.prototype, "orderTaskIds", void 0);
exports.ProjectOrder = ProjectOrder = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], ProjectOrder);
